<template>
    <div>

        <Transition enter-active-class="animate__animated animate__fadeIn"
                    leave-active-class="animate__animated animate__fadeOut">

            <div class="search-spots-for-current-list-container" v-show="isOpen">

                <div class="backdrop" @click="close()">
                </div>

                <Transition :enter-active-class="( screenInfo.md ? 'animate__animated animate__fadeInLeft' : 'animate__animated animate__bounceInUp')"
                            :leave-active-class="( screenInfo.md ? 'animate__animated animate__fadeOutLeft' : 'animate__animated animate__bounceOutDown')">

                    <div class="search-content" v-show="isOpen">
                        <Search @close="close()" :list="list"></Search>
                    </div>

                </Transition>
            </div>
        </Transition>
    </div>
</template>
<script>

import Search from './Search'
import Helpers from '@/mixins/Helpers'

export default {

    mixins:[Helpers],

    components:{
        Search
    },

    props:['list'],

    data(){
        return{
            isOpen : false,
        }
    },

    mounted(){
        let element = document.getElementById('add-a-spot-to-list')
        element.addEventListener('click', this.open)
        eventBus.$on('add-a-spot-to-list', this.open)
    },

    methods:{
        open(){
            this.isOpen = true
            $('body').addClass('no-scroll')
            this.$nextTick(() => $('#search-spots-input').focus())
        },

        close(){
            this.isOpen = false
            $('body').removeClass('no-scroll')
        }
    }
}
</script>
